var React = require('react');

function QG3i (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#AAA","d":"M40 80c0-22.091 17.909-40 40-40V0C35.817 0 0 35.818 0 80c0 44.183 35.817 80 80 80v-40c-22.091 0-40-17.909-40-40z","key":0}),React.createElement("path",{"fill":"#A0CFC6","d":"M108.292 108.284l28.284 28.284c31.242-31.242 31.242-81.895 0-113.137l-28.284 28.284c15.62 15.622 15.62 40.948 0 56.569z","key":1}),React.createElement("path",{"fill":"#4C372E","d":"M40 172h80v40H40z","key":2}),React.createElement("g",{"key":3},[React.createElement("path",{"fill":"#246648","d":"M51.716 108.284c15.621 15.621 40.948 15.621 56.569 0L51.716 51.715c-15.621 15.622-15.621 40.948 0 56.569z","key":0}),React.createElement("path",{"fill":"#3B588C","d":"M108.285 51.716c-15.621-15.621-40.948-15.621-56.569 0l56.569 56.569c15.621-15.622 15.621-40.948 0-56.569z","key":1})])]);
}

QG3i.defaultProps = {"viewBox":"0 0 160.007 212"};

module.exports = QG3i;

QG3i.default = QG3i;
